import React from 'react'

import HelpHardinessCard from './HelpHardinessCard'
import { getHardinessCards } from './hardinessCardsData'

const HelpHardinessCards = ({ language }) => (
  <div className="HelpHardinessCards">
    {getHardinessCards(language).map(card => (
      <HelpHardinessCard key={card.id} {...card} />
    ))}
  </div>
)

export default HelpHardinessCards
